(function () {
  function initBundle(root) {
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-raksha-tier]'));
    var products = Array.prototype.slice.call(root.querySelectorAll('[data-raksha-product]'));
    var notice = root.querySelector('[data-raksha-notice]');
    var selectedCount = root.querySelector('[data-raksha-selected-count]');
    var progress = root.querySelector('[data-raksha-progress]');
    var tierLabel = root.querySelector('[data-raksha-tier-label]');
    var summaryList = root.querySelector('[data-raksha-summary-list]');
    var total = root.querySelector('[data-raksha-total]');
    var addButton = root.querySelector('[data-raksha-add]');

    if (!tiers.length || !addButton) return;

    var state = {
      variantId: tiers[0].dataset.variantId,
      limit: Number(tiers[0].dataset.limit) || 1,
      title: tiers[0].dataset.title || tiers[0].textContent.trim(),
      price: tiers[0].dataset.price || '',
      quantities: {}
    };

    function selectedTotal() {
      return Object.keys(state.quantities).reduce(function (sum, id) {
        return sum + state.quantities[id];
      }, 0);
    }

    function selectedItems() {
      return products
        .map(function (card) {
          var id = card.dataset.productId;
          return {
            id: id,
            title: card.dataset.productTitle,
            image: card.dataset.productImage,
            qty: state.quantities[id] || 0
          };
        })
        .filter(function (item) {
          return item.qty > 0;
        });
    }

    function setNotice(message) {
      if (notice) notice.textContent = message;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function renderSummary() {
      var count = selectedTotal();
      var items = selectedItems();

      selectedCount.textContent = count + '/' + state.limit;
      progress.style.width = Math.min(100, (count / state.limit) * 100) + '%';
      tierLabel.textContent = state.title;
      total.textContent = state.price;
      addButton.disabled = count !== state.limit;

      products.forEach(function (card) {
        var id = card.dataset.productId;
        var qty = state.quantities[id] || 0;
        var add = card.querySelector('[data-raksha-card-add]');
        var controls = card.querySelector('[data-raksha-card-controls]');
        var qtyText = card.querySelector('[data-raksha-card-qty]');
        var plus = card.querySelector('[data-raksha-plus]');

        card.classList.toggle('is-selected', qty > 0);
        if (add) add.hidden = qty > 0;
        if (controls) controls.hidden = qty === 0;
        if (qtyText) qtyText.textContent = qty;
        if (plus) plus.disabled = count >= state.limit;
      });

      var html = items.map(function (item) {
        return [
          '<div class="raksha-summary-item">',
          item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<span class="raksha-summary-item__placeholder"></span>',
          '<div class="raksha-summary-item__title">' + escapeHtml(item.title) + '</div>',
          '<div class="raksha-summary-item__qty">',
          '<button type="button" data-raksha-summary-minus="' + escapeHtml(item.id) + '">-</button>',
          '<span>' + item.qty + '</span>',
          '<button type="button" data-raksha-summary-plus="' + escapeHtml(item.id) + '"' + (count >= state.limit ? ' disabled' : '') + '>+</button>',
          '</div>',
          '</div>'
        ].join('');
      }).join('');

      for (var slot = count; slot < state.limit; slot += 1) {
        html += '<div class="raksha-summary-slot"><span>+</span><p>Product ' + (slot + 1) + '</p></div>';
      }

      summaryList.innerHTML = html;

      if (count === state.limit) {
        setNotice('Bundle is complete. You can add it to cart now.');
      } else {
        setNotice('Choose ' + (state.limit - count) + ' more product' + (state.limit - count === 1 ? '' : 's') + ' for this box.');
      }
    }

    function changeQty(id, delta) {
      var current = state.quantities[id] || 0;
      var count = selectedTotal();

      if (delta > 0 && count >= state.limit) {
        setNotice('Your bundle is full. Remove an item to add another.');
        return;
      }

      var next = Math.max(0, current + delta);
      if (next === 0) {
        delete state.quantities[id];
      } else {
        state.quantities[id] = next;
      }

      renderSummary();
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        state.variantId = tier.dataset.variantId;
        state.limit = Number(tier.dataset.limit) || 1;
        state.title = tier.dataset.title || tier.textContent.trim();
        state.price = tier.dataset.price || '';

        tiers.forEach(function (button) {
          var isActive = button === tier;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });

        while (selectedTotal() > state.limit) {
          var ids = Object.keys(state.quantities);
          var lastId = ids[ids.length - 1];
          state.quantities[lastId] -= 1;
          if (state.quantities[lastId] <= 0) delete state.quantities[lastId];
        }

        renderSummary();
      });
    });

    products.forEach(function (card) {
      var id = card.dataset.productId;
      var add = card.querySelector('[data-raksha-card-add]');
      var minus = card.querySelector('[data-raksha-minus]');
      var plus = card.querySelector('[data-raksha-plus]');

      if (add) add.addEventListener('click', function () { changeQty(id, 1); });
      if (minus) minus.addEventListener('click', function () { changeQty(id, -1); });
      if (plus) plus.addEventListener('click', function () { changeQty(id, 1); });
    });

    summaryList.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-raksha-summary-minus]');
      var plus = event.target.closest('[data-raksha-summary-plus]');

      if (minus) changeQty(minus.dataset.rakshaSummaryMinus, -1);
      if (plus) changeQty(plus.dataset.rakshaSummaryPlus, 1);
    });

    addButton.addEventListener('click', function () {
      var count = selectedTotal();
      if (count !== state.limit) {
        setNotice('Please select exactly ' + state.limit + ' product' + (state.limit === 1 ? '' : 's') + ' before adding to cart.');
        return;
      }

      var selectionText = selectedItems().map(function (item) {
        return item.title + ' x' + item.qty;
      }).join(', ');

      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.style.display = 'none';

      [
        ['id', state.variantId],
        ['quantity', '1'],
        ['properties[Box]', state.title],
        ['properties[Selected products]', selectionText],
        ['return_to', '/discount/PREPAID100?redirect=/checkout']
      ].forEach(function (field) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = field[0];
        input.value = field[1];
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    });

    renderSummary();
  }

  function boot() {
    document.querySelectorAll('[data-raksha-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
